import { axios, Response } from '..'

export type Persona = {
  userId: string
  username: string
  avatarUrl: string
  personaType: string
  avatarName: string
}

const getAllPersonas = (): Response<Persona[]> => {
  return axios.get('/v1/personas')
}

export default getAllPersonas
